import React, { useState, useEffect } from 'react';
import './UpdateProductById.css';
import { API_BASE } from '../api';

const UpdateProductById = () => {
    const [editedProduct, setEditedProduct] = useState({});
    const [product, setProduct] = useState([]);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        getAllProducts();
    }, []);

    useEffect(() => {
        if (product[index]) {
            setEditedProduct(product[index]);
        }
    }, [product, index]);

    function getAllProducts() {
        fetch(API_BASE + "/")
            .then((response) => response.json())
            .then((data) => setProduct(Array.isArray(data) ? data : []))
            .catch((err) => console.error("Failed to load products:", err));
    }

    function getOneByOneProductNext() {
        if (product.length > 0) {
            if (index === product.length - 1) setIndex(0);
            else setIndex(index + 1);
        }
    }

    function getOneByOneProductPrev() {
        if (product.length > 0) {
            if (index === 0) setIndex(product.length - 1);
            else setIndex(index - 1);
        }
    }

    function handleUpdateProduct(e) {
        e.preventDefault();
        const payload = { ...editedProduct, _id: Number(editedProduct._id) };
        fetch(API_BASE + "/update", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data && data.message) {
                    alert(data.message);
                    getAllProducts();
                }
            })
            .catch((err) => {
                console.error("Update failed:", err);
                alert("Update failed. Try again.");
            });
    }

    return (
        <div className="update-product-container">
            <h3>Update Product</h3>
            <div className="update-product-buttons">
                <button className="prev-button" onClick={() => getOneByOneProductPrev()}>Prev</button>
                <button className="next-button" onClick={() => getOneByOneProductNext()}>Next</button>
            </div>
            {product[index] && (
                <div key={product[index]._id} className="update-product-details">
                    <img
                        src={product[index].image || `https://picsum.photos/seed/${product[index]._id}/80/80`}
                        alt={product[index].title}
                        width={30}
                        className="product-image"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://picsum.photos/seed/${product[index]._id}/80/80`;
                        }}
                    />
                    <div className="product-info">
                        <div>Id: {product[index]._id}</div>
                        <div>Title: {product[index].title}</div>
                        <div>Category: {product[index].category}</div>
                        <div>Price: {product[index].price}</div>
                        <div>Rate: {product[index].rating.rate} and Count: {product[index].rating.count}</div>
                    </div>
                    <form onSubmit={handleUpdateProduct} className="update-product-form">
                        {/* <input type="text" className="input-field" name="_id" placeholder="Enter the Products Id" onChange={(e) => setEditedProduct({ ...editedProduct, _id: e.target.value })} /> */}
                        <span>Title</span><input type="text" autocomplete="off" className="input-field" name="title" placeholder="Modify Title" value={editedProduct.title} onChange={(e) => setEditedProduct({ ...editedProduct, title: e.target.value })} />
                        <span>Price</span><input type="number" autocomplete="off" className="input-field" name="price" placeholder="Modify Price" value={editedProduct.price} onChange={(e) => setEditedProduct({ ...editedProduct, price: e.target.value })} />
                        <span>Description</span><input type="text" autocomplete="off" className="input-field" name="description" placeholder="Modify Description" value={editedProduct.description} onChange={(e) => setEditedProduct({ ...editedProduct, description: e.target.value })} />
                        <span>Category</span><input type="text" autocomplete="off" className="input-field" name="category" placeholder="Modify Category" value={editedProduct.category} onChange={(e) => setEditedProduct({ ...editedProduct, category: e.target.value })} />
                        <span>Image</span><input type="text" className="input-field" name="image" placeholder="Modify Image URL" value={editedProduct.image} onChange={(e) => setEditedProduct({ ...editedProduct, image: e.target.value })} />
                        {/* <input type="number" className="input-field" name="rate" placeholder="Modify Rating" value={editedProduct.rating.rate} onChange={(e) => setEditedProduct({ ...editedProduct, rating: { ...editedProduct.rating, rate: e.target.value } })} />
                        <input type="number" className="input-field" name="count" placeholder="Modify Count" value={editedProduct.rating.count} onChange={(e) => setEditedProduct({ ...editedProduct, rating: { ...editedProduct.rating, count: e.target.value } })} /> 
                        */}
                        <span>Rate</span><input type="number" autocomplete="off" className="input-field" name="rate" placeholder="Modify Rating" value={editedProduct.rating?.rate || ''} onChange={(e) => setEditedProduct({ ...editedProduct, rating: { ...editedProduct.rating, rate: e.target.value } })} />
                        <span>Count</span><input type="number" autocomplete="off" className="input-field" name="count" placeholder="Modify Count" value={editedProduct.rating?.count || ''} onChange={(e) => setEditedProduct({ ...editedProduct, rating: { ...editedProduct.rating, count: e.target.value } })} />

                        <button type="submit" className="update-button">Update</button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default UpdateProductById;


